export const isIncludedInFilters = (srType, srTypeId, filters) => {
  const srTypeFilter = filters?.find((filter) => filter?.field === 'srType');
  const isSrTypeNameIncludedInTheFilter = srTypeFilter?.displayKeys?.[0]
    ?.toLowerCase()
    ?.includes(srType?.toLowerCase());
  const isSrTypeIdIncludedInTheFilter = String(srTypeFilter?.values?.[0]) === String(srTypeId);

  return isSrTypeNameIncludedInTheFilter || isSrTypeIdIncludedInTheFilter;
};
